export default __webpack_public_path__ + "static/media/voucher-day-work.058ef4a0.jpg";